// extracted by mini-css-extract-plugin
export default {"adminDashboard":"Dashboard_adminDashboard__6v7Zd","headerButtonContainer":"Dashboard_headerButtonContainer__ClxoO"};